export function extendArray(constructor: Function) {
  Object.getOwnPropertyNames(constructor.prototype)
    .filter((name) => name !== "constructor")
    .forEach((name) => {
      const attributes = Object.getOwnPropertyDescriptor(constructor.prototype, name);
      Object.defineProperty(Array.prototype, name, attributes!);
    });
}
